<template>
    <div class="school-channel">
        <div class="school-channel__main" ref="mainContainer">
            <div class="school-channel__banner">
                <v-lazy-image :src="source.banner" alt="" />
                <button class="school-channel__intro" @click="showIntro=true">领取说明</button>
            </div>
            <div class="school-channel__course--content">
                <v-lazy-image :src="source.courseContent" alt="" />

                <button class="school-channel__get-course"  @click="toggleDialogForm('2','立即领取')">
                    <v-lazy-image :src="source.getBtn" alt="" />
                </button>
            </div>
            <div class="school-channel__teach-way">
                <v-lazy-image :src="source.teachWay" alt="" />
            </div>
            <div class="school-channel__teacher">
                <v-lazy-image :src="source.teacher" alt="" />
            </div>
            <div class="school-channel__teacher--intro">
                <zm-swiper swipeid="swipe" :autoplay="3000" :loop="false" effect="slide" ref="swiper">
                    <div class="swiper-slide school-channel__teacher--intro-A" slot="swiper-con">
                        <img src="https://web-data.zmlearn.com/image/mfZBxyVs7WWexdebrzuCHt/teacherA.png" alt="" />
                    </div>
                    <div class="swiper-slide school-channel__teacher--intro-B" slot="swiper-con">
                        <img src="https://web-data.zmlearn.com/image/eFVQ6WrUUdtbrePYHSnGgj/teacherB.png" alt="" />
                    </div>
                </zm-swiper>
            </div>
            <div class="school-channel__parent">
                <v-lazy-image :src="source.parentCourse" alt="" />
            </div>
            <div class="school-channel__study">
                <v-lazy-image :src="source.study_01" alt="" />
                <v-lazy-image :src="source.study_02" alt="" />
                <v-lazy-image :src="source.study_03" alt="" />
            </div>
        </div>
        <div ref='fixedBottom' :class="['school-channel__fixed', fixedBottom ? 'school-channel__fixed--bottom' : '']"  @click="toggleDialogForm('3','底部立即领取')">
            <v-lazy-image :src="source.fixed" alt="点击0元抢简直398元少儿思维礼包"/>
        </div>
        <div class="school-channel__dialog--form" v-if="showDialogForm">
            <div class="school-channel__dialog--content"  ref="lessonFormContent">
                <div class="school-channel__dialog--box">
                    <lesson-form btnText="立即领取"></lesson-form>
                    <img :src="source.close" alt="关闭" @click="toggleDialogForm(null, '关闭')" class="school-channel__dialog--close"/>
                </div>
            </div>
        </div>
        <div class="school-channel__intro--container" v-show="showIntro">
            <activity-intro :showIntro.sync="showIntro" class="school-channel__intro--content"></activity-intro>
        </div>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";
    import lessonForm from "./lesson-form";
    import activityIntro from "./activity-intro";
    import { KidsWeChatShare } from '@/assets/js/shareMessage'

    export default {
        name: "SchoolChannel",
        data() {
            return {
                source: {
                    study_03: 'https://web-data.zmlearn.com/image/sooRQA1wvL5bA65fn4vyv6/study_03.png',
                    study_02: 'https://web-data.zmlearn.com/image/cieEFR8Z4B47UHd83Uy6xt/study_02.png',
                    teacherA: 'https://web-data.zmlearn.com/image/mfZBxyVs7WWexdebrzuCHt/teacherA.png',
                    teacherB: 'https://web-data.zmlearn.com/image/eFVQ6WrUUdtbrePYHSnGgj/teacherB.png',
                    parentCourse: 'https://web-data.zmlearn.com/image/mp2fZLsYYYB29rHatWqMWm/parent.png',
                    banner: 'https://web-data.zmlearn.com/image/9Yb6qet2ekY8H3QpSQcRYB/banner.png',
                    teachWay: 'https://web-data.zmlearn.com/image/uF8C1oZdSrH16pnrb4ev23/teachWay.png',
                    courseContent: 'https://web-data.zmlearn.com/image/9Qm2ZknPhYxpKuZuv756vb/content.png',
                    teacher: 'https://web-data.zmlearn.com/image/fkeAEaqyhyzJ6VSzUvd41d/teacher.png',
                    fixed: 'https://web-data.zmlearn.com/image/f2L2Lv3U1TnFZJi5JTNiUv/fixed.png',
                    getBtn: 'https://web-data.zmlearn.com/image/wQfqn43wQ5SnrB7RM84nRV/getbtn.png',
                    study_01: 'https://web-data.zmlearn.com/image/gCuLjpWmiGphHWgXj2bPVo/study_01.png',
                    close: 'https://web-data.zmlearn.com/image/pMeJFjz6QKFohpr9b4wPSH/icon_close.png'
                },
                fixedBottom: false,
                showDialogForm: false,
                showIntro: false,
                LOGINFO: {}
            }
        },
        components: {
            VLazyImage,
            lessonForm,
            activityIntro
        },
        created() {
          this.initLogInfo(this.$route.query.channel_code);
        },
        mounted() {
            this.sendEvent(this.LOGINFO['1']);
            this.$nextTick(() => {
                window.addEventListener("scroll", this.checkPosition, false);
                this.checkPosition();
                KidsWeChatShare({
                    title: '掌门少儿五大礼包免费送',
                    desc: '送你一节我家孩子也在学的少儿思维训练课',
                    imgUrl: 'https://activity-static.zmlearn.com/m/zmsr.png',
                });
            });
        },
        methods :{
            checkPosition() {
                const mainContainer = this.$refs.mainContainer;
                if (!mainContainer) { return; }
                const screenHeight = window.screen.availHeight;
                const scrollY = window.scrollY;
                const footerBottomY = mainContainer.clientHeight - screenHeight;
                this.fixedBottom = scrollY > screenHeight && scrollY < footerBottomY ;
            },
            toggleDialogForm(type, from) {
                type && this.sendEvent(this.LOGINFO[type]);
                this.showDialogForm = !this.showDialogForm;
            },
            sendEvent(data) {
                ZM_JSSDK && ZM_JSSDK.sendEvent(data);
            },
            initLogInfo(code) {
                this.LOGINFO = {
                    '1': {
                        eventId: 'enter_kid_act37_homepage',
                        eventParam: {
                            code,
                        }
                    },
                    '2': {
                        eventId: 'click_kid_act37_ljlq',
                        eventParam: {
                            code,
                            position: '1', // 页面中央
                        }
                    },
                    '3': {
                        eventId: 'click_kid_act37_ljlq',
                        eventParam: {
                            code,
                            position: '2', // 悬浮底部
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .school-channel {
        position: relative;
        font-size: 0;
        background-color: #FFF4D5;
        img {
            width: 100%;
        }
        &__course--content {
            position: relative;
            margin: px2rem(-120) 0 px2rem(45);
        }
        &__get-course {
            position: absolute;
            width: px2rem(630);
            bottom: px2rem(80);
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            font-size: 0;
            background-color: transparent;
            border: none;
        }
        &__teach-way {
            margin-bottom: px2rem(76);
        }
        &__teacher {
            margin-bottom: px2rem(32);
            &--intro {
                position: relative;
                width: px2rem(684);
                margin: 0 auto px2rem(37);
            }
        }
        &__parent {
            padding-bottom: px2rem(80);
            background-color: #fff;
        }
        &__study {
            background-color: #fff;
        }
        &__fixed {
            background-color: #fff;
            &--bottom {
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: 1;
                background-color: transparent;
            }
        }
        &__dialog {
            &--form {
                position: absolute;
                z-index: 999;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.7);
            }
            &--content {
                position: fixed;
                width: px2rem(688);
                height: 100%;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
            &--box {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                width: 100%;
            }
            &--close {
                width: px2rem(60) !important;
                margin-top: px2rem(32);
            }
        }
        &__intro {
            position: absolute;
            right: 0;
            top: px2rem(180);
            padding: px2rem(12) 0 px2rem(10) px2rem(20);
            border: none;
            background-color: rgba(255,0,0, 0.75);
            border-radius: px2rem(32) 0 0 px2rem(32);
            line-height: px2rem(32);
            font-size: px2rem(28);
            color: #fff;
            &--container {
                width: 100%;
                height: 100%;
                position: fixed;
                top: 0;
                left: 0;
                background-color: rgba(0,0,0,.6);
                z-index: 2;
            }
            &--content {
                position: fixed;
                top:50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                width: px2rem(566);
            }
        }
    }
</style>
<style lang="scss">
    .school-channel {
        &__teacher--intro {
            .swiper-container {
                padding-bottom: px2rem(50);
            }
            .swiper-pagination {
                position: absolute;
                bottom: 0 !important;
                .swiper-pagination-bullet {
                    background: rgba(255,173,16, 1);
                    opacity: 0.6;
                    transition: all 0.25s ease;
                }
                .swiper-pagination-bullet-active {
                    width: px2rem(50);
                    height: px2rem(16);
                    border-radius: px2rem(30);
                    background: #ffad10;
                    transition: all 0.25s ease;
                }
            }
        }
    }
</style>
